import { useApi } from '@/api';
import {
  KpiCard,
  Link,
  Banner,
  Page,
  PageSkeleton,
  LinkButton
} from '@/components';
import { useSearchParams } from '@/hooks';
import { tokensMapping } from '@/utils/tokens';
import {
  EtherScanPictogram,
  Flex,
  Heading,
  LinkWrapper,
  Box
} from '@blockanalitica/ui';
import EventsTable from './EventsTable';
import HistoricTabs from './HistoricTabs';
import TreasuryAssetsShare from './TreasuryAssetDistribution';

export default function TreasuryPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');
  const [data, error] = useApi({
    url: '/treasury/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <Heading size="1">
            <Flex gap="xs">
              Treasury
              <a
                href={`https://etherscan.io/address/0xbe8e3e3618f7474f8cb1d074a26affef007e98fb`}
                target="_blank"
                rel="noreferrer">
                <EtherScanPictogram size="0" />
              </a>
            </Flex>
          </Heading>
        }>
        <Banner>
          <Box paddingTop="xs" paddingBottom="m" maxWidth="85%">
            <Heading size="2">About the Sky Protocol Treasury</Heading>
            <br />
            Live view of protocol assets, surplus, and flows. Sky
            Protocol&apos;s treasury and its in- and outflows will eventually be
            managed by the Sky Treasury Management Function.
          </Box>
        </Banner>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Treasury balance"
            data={data}
            field="treasury_balance_usd"
            options={{
              currency: 'USD'
            }}
          />
          <KpiCard
            title="SKY held in treasury"
            variant="sky"
            data={data}
            field="sky_balance"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  iconSize: '3',
                  currency: tokensMapping('SKY')
                }
              }
            }}
          />
        </Flex>

        <HistoricTabs />
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <LinkWrapper
            to="/buyback"
            // @ts-ignore
            as={Link}
            variant="kpiCardLinkWithBlendMode">
            <KpiCard
              title="Total SKY buyback"
              variant="sky"
              data={data}
              field="sky_cumulative_buyback"
              options={{
                linkArrow: true,
                valueOptions: {
                  currencyValueOptions: {
                    iconSize: '3',
                    currency: tokensMapping('SKY')
                  }
                }
              }}
            />
          </LinkWrapper>
          <LinkWrapper
            to="/capital-backstop"
            // @ts-ignore
            as={Link}
            variant="kpiCardLinkWithBlendMode">
            <KpiCard
              title="Aggregate Backstop Capital"
              variant="usds"
              data={data}
              field="backstop_balance_usd"
              options={{
                linkArrow: true,
                valueOptions: {
                  currencyValueOptions: {
                    iconSize: '3',
                    currency: tokensMapping('USDS')
                  }
                }
              }}
            />
          </LinkWrapper>
        </Flex>
        <TreasuryAssetsShare />
        {/* <TreasuryAssetsPolShare /> */}
        {/* <ActivityCard url={`/treasury/activity/`} linkTo="activity" /> */}
        <Flex justifyContent="space-between">
          <Heading size="3">Latest Transfers</Heading>
          <LinkButton variant="secondary" to="/treasury/activity/">
            view all
          </LinkButton>
        </Flex>
        <EventsTable />
      </Page>
    );
  }
  return <PageSkeleton />;
}
